
/*jshint esversion: 6 */
const state = {
    resources: [],  
    resid: '',
};

const mutations = {
    loadResources(state, resources) {
        //console.log('resources loaded')
        state.resources = resources;    
      },
    setResid(state, id) {
        state.resid = id;    
    },      
};

const actions = { 
    loadResources (context, { vm }) {
        const db = vm.$firebase.firestore();
    
        db.collection('resources').orderBy('order')
        .get().then(res => {
          const resources = [];
          res.docs.forEach (doc => {
            resources.push({
              id: doc.id,
              name: doc.data().name,
              order: doc.data().order
            });        
          });
          context.commit('loadResources', resources);
          console.log("#loadResources done#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() ); 
        }); 
    },   
    setResid(context, id) {
        context.commit('setResid', id);
    },      
};
  
const getters = {
    resources: state => {
        return state.resources;
    },    
    resid: state => {
        return state.resid;
    },        
};

export default {
    state,
    mutations,
    actions,
    getters
};
   